import {
    LinkGeneralInterface,
    LinkInterface,
} from 'components/interfaces/GeneralInterface';

export const getFilteredLinks = <T extends string | string[]>(
    configInnerPageMenu: string[],
    links: LinkGeneralInterface<T>[]
): LinkGeneralInterface<T>[] => {
    const transformedLinks: LinkGeneralInterface<T>[] = [];

    links.forEach((link) => {
        if (
            !link.idx ||
            configInnerPageMenu.some((cfipm) => cfipm === link.idx)
        ) {
            transformedLinks.push({
                ...link,
                items: !link.items
                    ? null
                    : link.items.filter((li) =>
                          configInnerPageMenu.some((cfipm) => cfipm === li.idx)
                      ),
            });
        }
    });
    return transformedLinks;
};

export const getFilterLinksInnerCb =
    (configInnerPageMenu: string[], links: LinkInterface<string>[]) =>
    ({ idx }: LinkInterface<string>): boolean => {
        if (configInnerPageMenu.some((cipm) => cipm === idx)) {
            return true;
        } else if (
            !idx &&
            configInnerPageMenu.some((m) =>
                links
                    .filter((l) => l.idx)
                    .map((l) => l.idx)
                    .some((l) => l === m)
            )
        ) {
            return true;
        }

        return false;
    };

export const getFilterSubLinksInnerCb = (
    configInnerSubPageMenu: string[],
    link: LinkGeneralInterface<string>
): boolean => {
    if (configInnerSubPageMenu.indexOf(link.idx) !== -1) {
        return true;
    } else if (!link && configInnerSubPageMenu.some((m) => link.idx === m)) {
        return true;
    }

    return false;
};
